module.exports = __webpack_public_path__ + "img/mercer-university-logo.9b8b14f1.png";